<!--
  筛选
  lovi 2020-06-23
-->
<template>
  <div>
    <div class="search">
      <div class="time">
        <div class="item" @click="chooseDate(1)">
          <span>{{ _formatDate(startDate) }}</span>
          <van-icon name="notes-o" />
        </div>
        <i class="to">-</i>
        <div class="item" @click="chooseDate(2)">
          <span>{{ _formatDate(endDate) }}</span>
          <van-icon name="notes-o" />
        </div>
      </div>
      <div class="btn" @click="clickFilter">
        {{ $t("common.screen") }}
      </div>
    </div>
    <div class="count" v-if="countflag">
      <p v-for="(item, index) in countData" :key="index">
        <label>{{ item.label }}:</label>
        <span>{{ item.value }}P</span>
      </p>
    </div>

    <van-popup
      v-model="filterFlag"
      :class="countflag ? 'popup-filter has-count' : 'popup-filter'"
      :overlay-class="countflag ? 'overlay-filter has-count' : 'overlay-filter'"
      position="top"
    >
      <div class="filter-list" v-for="(list, index) in list" :key="index">
        <h3 v-if="list.title != ''">{{ list.title }}</h3>
        <div class="filter-item">
          <div
            class="item"
            :class="{ active: filterList[index].key === item.key }"
            v-for="(item, itemIndex) in list.list"
            :key="itemIndex"
            @click="chooseItem(index, item)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="dateFlag" position="bottom" get-container="body">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="changeDate"
        @cancel="dateFlag = false"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      //筛选列表
      type: Array,
      default: function() {
        return [];
      }
    },
    countflag: {
      //是否显示统计数据
      type: Boolean,
      default: false
    },
    countData: {
      //统计数据
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {},
  data() {
    return {
      dateFlag: false,
      startDate: new Date(),
      endDate: new Date(),
      currentDate: new Date(),
      maxDate: new Date(),
      dateType: 0, //选择日期的类型，1是起始，2是结束
      filterFlag: false,
      filterList: []
    };
  },
  created() {
    let vm = this;
    vm.filterList = [];
    for (let i = 0; i < vm.countData.length; i++) {
      let obj = {};
      obj.key = "";
      vm.filterList.push(obj);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    clickFilter() {
      this.filterFlag = !this.filterFlag;
    },
    formatter(type, val) {
      // 自定义日期文案
      if (type === "year") {
        return val + this.$t("common.year");
      } else if (type === "month") {
        return val + this.$t("common.month");
      } else if (type === "day") {
        return val + this.$t("common.days");
      }
      return val;
    },
    chooseItem(index, child) {
      //选择条件
      let vm = this;
      vm.$set(vm.filterList[index], "key", child.key);
      vm.setFilter();
      vm.filterFlag = false;
    },
    chooseDate(type) {
      //选择日期
      let vm = this;
      vm.dateType = type;
      if (vm.dateType == 1) {
        vm.currentDate = vm.startDate;
      } else if (vm.dateType == 2) {
        vm.currentDate = vm.endDate;
      }
      vm.dateFlag = true;
    },
    changeDate(date) {
      //修改日期
      let vm = this;
      let start_date = vm.startDate;
      let end_date = vm.endDate;
      if (vm.dateType == 1) {
        start_date = date;
      } else if (vm.dateType == 2) {
        end_date = date;
      }
      if (vm._formatDate(start_date) > vm._formatDate(end_date)) {
        vm.$toast({
          message: vm.$t("common.endTimeCannotLessBeginningTime"),
          onClose() {
            start_date = vm.startDate;
            end_date = vm.endDate;
            vm.startDate = start_date;
            vm.endDate = end_date;
            vm.dateFlag = false;
          }
        });
        return false;
      }
      vm.startDate = start_date;
      vm.endDate = end_date;
      vm.setFilter();
      vm.dateFlag = false;
    },
    setFilter() {
      let vm = this;
      let obj = {};
      obj.startDate = vm._formatDate(vm.startDate);
      obj.endDate = vm._formatDate(vm.endDate);
      obj.filterList = vm.filterList;
      vm.$emit("getFilterData", obj);
      console.log("getFilterData", obj);
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
/deep/.overlay-filter {
  z-index: 81 !important;
  top: 94px;
  &.has-count {
    top: 94px + 38px;
  }
}
/deep/.popup-filter {
  z-index: 82 !important;
  top: 94px;
  &.has-count {
    top: 94px + 38px;
  }
}

.filter-list {
  padding: 5px 15px;
  .filter-item {
    display: flex;
    justify-content: flex-start;
    flex-flow: wrap;
    .item {
      width: 33.33%;
      padding: 5px;
      &.active {
        span {
          background: rgba(74, 144, 226, 0.2) url("@{imgUrl}public/checked.png")
            no-repeat right bottom;
          background-size: 25px 20px;
          border-color: #2042ab;
          color: #1c64d0;
        }
      }
      span {
        padding: 0 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 32px;
        font-size: 12px;
        word-wrap: break-word;
        // word-break: break-all;
        line-height: 1;
        background: #eff2f5;
        border: 1.1px solid #eff2f5;
        border-radius: 4px;
      }
    }
  }
}
.search,
.count {
  z-index: 90;
  position: fixed;
  left: 0;
  right: 0;
  padding: 0 15px;
  background: #fff;
  border-bottom: 1.1px solid #e4e4e4;
}
.search {
  top: 44px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .time {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    .item {
      width: 48%;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #4a4a4a;
      background: #f0f2f5;
      border-radius: 3px;
      padding: 0 6px;
      span {
        font-size: 12px;
      }
      /deep/.van-icon {
        color: #4a4a4a;
        font-size: 16px;
      }
    }
    .to {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 4%;
    }
  }
  .btn {
    margin-left: 10px;
    width: 46px;
    height: 26px;
    background: #2042ab;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #fff;
  }
}

.count {
  top: 94px;
  height: 38px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #4a4a4a;
  p + p {
    margin-left: 8px;
  }
}
</style>
